export const linkList = [
  {
    key: '1',
    title: '产品服务',
    path: '/product-service'
    // children: [
    //   { key: '1', label: '税纪云', path: '/product/newTaxera' },
    //   { key: '2', label: 'Taxcellent', path: '/product/taxcellent' },
    //   { key: '3', label: '金税一言', path: '/product/chataxera' },
    //   { key: '4', label: '法规库', path: '/product/lawLibrary' },
    //   { key: '5', label: '行业数据库', path: '/product/ibd' }
    // ]
  },
  // {
  //   key: '2',
  //   title: '服务咨询',
  //   path: '',
  //   children: [
  //     { key: '1', label: '税务咨询', path: '/service/product-tax-consulting' },
  //     { key: '2', label: '外包服务', path: '/service/product-outsourcing-services' },
  //     { key: '3', label: '国际服务', path: '/service/product-global-platform' }
  //   ]
  // },
  // {
  //   key: '2',
  //   title: '解决方案',
  //   path: '',
  //   children: [
  //     { key: '1', label: '连锁零售', path: '/solution-chain-retail' }
  //   ]
  // },
  {
    key: '3',
    title: '行业案例',
    path: '/case'
    // children: [
    //   { key: '1', label: '妍丽', path: '/case/details?key=01' },
    //   { key: '2', label: '名创优品', path: '/case/details?key=02' },
    //   { key: '3', label: '瑞派宠物', path: '/case/details?key=03' },
    //   { key: '4', label: '英孚教育', path: '/case/details?key=04' },
    //   { key: '5', label: '比亚迪', path: '/case/details?key=05' },
    //   { key: '6', label: '互联网货运', path: '/case/details?key=06' },
    //   { key: '7', label: '建筑用工', path: '/case/details?key=07' },
    //   { key: '8', label: '国家能源', path: '/case/details?key=08' },
    //   { key: '9', label: '吉田拉链', path: '/case/details?key=09' }
    // ]
  },
  {
    key: '4',
    title: '新闻中心',
    path: '',
    children: [
      { key: '1', label: '研讨活动', path: '/news-center' },
      { key: '2', label: '新闻动态', path: '/news-center' }
    ]
  },
  {
    key: '5',
    title: '财税沙龙',
    path: '/salon-tax'
    // children: [
    //   {
    //     key: '1',
    //     label: '互动论坛',
    //     path: '/salon-tax'
    //   },
    //   {
    //     key: '2',
    //     label: '智慧税务',
    //     path: '/salon-tax'
    //   },
    //   {
    //     key: '3',
    //     label: '行业观点',
    //     path: '/salon-tax'
    //   },
    //   {
    //     key: '4',
    //     label: '政策热点',
    //     path: '/salon-tax'
    //   }
    // ]
  },
  {
    key: '6',
    title: '关于华盟',
    path: '',
    children: [
      { key: '1', label: '华盟介绍', path: '/introduce' },
      { key: '2', label: '联系我们', path: '/about' }
      // {
      //   key: '3',
      //   label: '加入我们',
      //   path: '/product/ftc'
      // }
    ]
  },
  {
    key: '7',
    title: '招聘',
    path: '',
    children: [
      { key: '1', label: '华盟招聘', path: '/invite-job' },
      { key: '2', label: '华盟风采', path: '/hm-style' }
    ]
  }
]

export const certificateList = []



// WEBPACK FOOTER //
// ./src/layout/footer/data.js